import React from 'react';
import { Link } from 'react-router-dom';
import { clientReviews } from '../data/mock';
import { Star, Quote, ArrowRight } from 'lucide-react';

// Surfaces a couple of GENUINE existing client quotes (no fabrication).
export const ReviewSnippets = ({ ids = [], heading = 'What clients say', subheading = '' }) => {
  const picks = ids.map((id) => clientReviews.find((r) => r.id === id)).filter(Boolean);
  if (picks.length === 0) return null;

  return (
    <section className="py-16 sm:py-20 bg-slate-900/30" data-testid="review-snippets">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">{heading}</h2>
          {subheading && <p className="text-slate-400 text-sm sm:text-base">{subheading}</p>}
        </div>
        <div className="grid sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {picks.map((r) => {
            const quote = Array.isArray(r.text) ? r.text[0] : r.text;
            return (
              <div key={r.id} className="bg-slate-900/60 border border-slate-800 rounded-2xl p-6 flex flex-col" data-testid={`review-snippet-${r.id}`}>
                <div className="flex items-center gap-1 mb-3" aria-label={`${r.rating || 5} out of 5`}>
                  {Array.from({ length: r.rating || 5 }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" aria-hidden="true" />
                  ))}
                </div>
                <Quote className="w-6 h-6 text-blue-400/50 mb-2" aria-hidden="true" />
                <p className="text-slate-300 text-sm sm:text-base leading-relaxed mb-4 line-clamp-5">{quote}</p>
                <div className="mt-auto">
                  <p className="text-white font-semibold text-sm">{r.name}</p>
                  {r.program && <p className="text-slate-500 text-xs">{r.program}</p>}
                </div>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-8">
          <Link to="/reviews" className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-semibold text-sm" data-testid="review-snippets-all">
            Read more client experiences <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ReviewSnippets;
